import React from 'react'
import moment from 'moment'
import { SelectField } from '@adc/ui-core'

const MONTHS = moment.monthsShort().map((month, index) => ({
  key: index + 1,
  text: month,
  value: index + 1,
}))

const Month = props => {
  return (
    <SelectField
      autoComplete='cc-exp-month'
      label='Month'
      options={MONTHS}
      {...props}
    />
  )
}

export default Month
